import { styled } from '@linaria/react'

export const Wrapper = styled.div`
  padding: 0 !important;
  overflow: hidden;
  margin-bottom: ${props => (props.overlapBottom ? '-13rem' : '0')} !important;
`
export const CircleWrap = styled.div`
  width: 120vw;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  overflow: hidden;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (max-width: 992px) {
    width: 200vw;
  }
`

export const PageHeaderWrapper = styled.div`
  --text-color: var(--white);

  color: var(--text-color);
  background: var(--blue-gradient);
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 110vh;
  padding: 13rem 0;
  position: relative;
  overflow: hidden;
  width: 100vw;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    padding: 10rem 0 13rem 0;
  }
`

export const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;

  #mouse-parallax-container {
    height: 100%;
    width: 100%;
  }

  .parallax-bg,
  .parallax-decor {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const Decor = styled.img`
  position: absolute;
  z-index: 1;
  cursor: ${props => (props.isEditor ? 'move' : '')};
`

export const BGImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 102% !important;
  height: 102% !important;
  object-fit: cover;
  object-position: top center;
`

export const Content = styled.div`
  position: relative;
  z-index: 1;
`

export const SideContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 55%;
  min-width: 380px;
  margin: 0 0 50px auto;

  @media screen and (max-width: 768px) {
    max-width: none;
    min-width: auto;
  }
`

export const Title = styled.h2`
  display: block;
  padding: 0;
  margin-bottom: 2rem;
`

export const Text = styled.p`
  margin-bottom: 2rem;
`
